// @flow strict
import type {Sort} from 'src/types/audience-csv-list';
import type {AtsEntity} from 'src/types/ats-entities';
import type {ATSListData} from 'src/types/audience-ats-list';
import type {AudienceATSListActions} from 'src/action-creators/audience-ats-list';

import {
  RECEIVE_ATS_LISTS,
  RECEIVE_ATS_ENTITIES,
  RECEIVE_ATS_LIST_SORT,
  RECEIVE_ATS_LIST_QUERY,
  RECEIVE_ATS_LIST_FILTER,
  RECEIVE_ATS_LIST_REFETCH,
  RECEIVE_ATS_LIST_PAGE_NUMBER,
} from 'src/action-creators/audience-ats-list';


export type AudienceATSListState = {
  sort: Sort,
  lists: Array<ATSListData>,
  query: string,
  refetch: boolean,
  listsMap: Map<number, Array<ATSListData>>,
  totalLists: number,
  pageNumber: number,
  totalPages: number,
  atsEntities: Array<AtsEntity>,
  otherFilters: $Partial<{status: Array<string>, entity: Array<string>}>,
};

const initialState = {
  sort: {sortBy: 'lastUserActionAt', sortOrder: 'desc'},
  lists: [],
  query: '',
  refetch: false,
  listsMap: new Map(),
  totalLists: 0,
  pageNumber: 1,
  totalPages: 1,
  atsEntities: [],
  otherFilters: {status: [], entity: []},
};

export default (
  state: AudienceATSListState = initialState,
  action: AudienceATSListActions,
): AudienceATSListState => {
  switch (action.type) {
    case RECEIVE_ATS_LISTS: {
      const {totalLists, totalPages, pageNo, lists, isNew} = action.payload;
      const listsMap = isNew ? new Map() : new Map(state.listsMap);

      return {
        ...state,
        lists,
        listsMap: listsMap.set(pageNo, lists),
        totalLists,
        totalPages,
      };
    }
    case RECEIVE_ATS_ENTITIES: {
      return {
        ...state,
        atsEntities: action.payload,
      };
    }
    case RECEIVE_ATS_LIST_SORT: {
      return {
        ...state,
        pageNumber: 1,
        sort: action.payload,
      };
    }
    case RECEIVE_ATS_LIST_QUERY: {
      return {
        ...state,
        pageNumber: 1,
        query: action.payload,
      };
    }
    case RECEIVE_ATS_LIST_FILTER: {
      const {field, value} = action.payload;
      return {
        ...state,
        pageNumber: 1,
        otherFilters: {
          ...state.otherFilters,
          [field]: value || [],
        },
      };
    }
    case RECEIVE_ATS_LIST_REFETCH: {
      return {
        ...state,
        pageNumber: 1,
        refetch: !state.refetch,
      };
    }
    case RECEIVE_ATS_LIST_PAGE_NUMBER: {
      return {
        ...state,
        pageNumber: action.payload,
      };
    }
  }

  return state;
};
